import { forwardRef, type PropsWithChildren } from 'react';

import { cn } from '@repo/utils/common';

interface ContainerProps extends PropsWithChildren {
  className?: string;
  children?: React.ReactNode;
}

export const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn('container mx-auto px-4 max-xl:max-w-none sm:px-6', className)}
        {...props}
      >
        {children}
      </div>
    );
  },
);

Container.displayName = 'Container';
